import { nanoid } from "@reduxjs/toolkit";

const TEMP_THREAD_PREFIX = "temp-thread-";
const TEMP_MESSAGE_PREFIX = "temp-msg-";

/**
 * Creates a temporary client-side thread ID for threads
 * not yet persisted by the server.
 * @returns A unique string prefixed with `temp-`.
 */
export const createTemporaryThreadId = (): string =>
  `${TEMP_THREAD_PREFIX}${nanoid()}`;

/**
 * Checks whether a thread ID is a temporary client-generated identifier.
 * @param threadId - The thread identifier to check.
 * @returns `true` if the ID starts with the temporary prefix.
 */
export const isTemporaryThreadId = (threadId: string): boolean =>
  threadId.startsWith(TEMP_THREAD_PREFIX);

/**
 * Creates a temporary client-side message ID for optimistic messages
 * not yet confirmed by the server.
 * @returns A unique string prefixed with `temp-msg-`.
 */
export const createTemporaryMessageId = (): string =>
  `${TEMP_MESSAGE_PREFIX}${nanoid()}`;

/**
 * Checks whether a message ID is a temporary client-generated identifier.
 * @param messageId - The message identifier to check.
 * @returns `true` if the ID starts with the temporary message prefix.
 */
export const isTemporaryMessageId = (messageId: string): boolean =>
  messageId.startsWith(TEMP_MESSAGE_PREFIX);
